import { render, staticRenderFns } from "./returnExchangeRecords.vue?vue&type=template&id=7fa45e6e&"
import script from "./returnExchangeRecords.vue?vue&type=script&lang=ts&"
export * from "./returnExchangeRecords.vue?vue&type=script&lang=ts&"
import style0 from "./returnExchangeRecords.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports